import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      const u = await register(name, email, password);
      toast.success(`Welcome, ${u.name}! 50 free tokens added.`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F5F7FA]">
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center mb-12">
            <img src="/promptyai-logo.png" alt="Promptyai.app" className="h-16 w-auto object-contain" />
          </Link>
          <h1 className="font-display text-4xl font-bold tracking-tight mb-2">Start crafting better prompts.</h1>
          <p className="text-[#64748B] mb-8">Get 50 free tokens every month. No credit card required.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="name">Full name</Label>
              <Input id="name" data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#14B8A6] hover:bg-[#0D9488] text-white" data-testid="register-submit">
              {loading ? "Creating account…" : "Create free account"}
            </Button>
            <p className="text-sm text-[#64748B] text-center">
              Already have an account? <Link to="/login" className="text-[#1F3A8A] font-semibold hover:underline">Sign in</Link>
            </p>
          </form>
        </div>
      </div>
      <div className="hidden lg:block relative bg-[#1F3A8A] bg-grid-dark overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1F3A8A] via-[#1F3A8A] to-[#14B8A6]/30"></div>
        <div className="relative h-full flex items-end p-12 text-white">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6] mb-3">Free trial</div>
            <p className="font-display text-3xl font-bold leading-tight max-w-md">
              Start with 50 free tokens every month. Upgrade only when you're hooked.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
